import {ContainsFilter} from "./contains.filter";
import {FilterObject} from "./filter-object";

export class ContainsMultipleFilter extends FilterObject<any> {

  constainsFilter = new ContainsFilter();

  filter(itemToFiltre: any): boolean {
    return this.doFilter(itemToFiltre, this.field, this.values);
  }

    doFilter(itemToFiltre: any, field: any, values: any): boolean {
        if (values == null) {
            return true;
        }
    let result = false;
        if (field == null) {
            field = Object.keys(itemToFiltre);
        }
    field.forEach((aField: string) => {
        if (Array.isArray(values)) {
            values.forEach(value => {
                result = result || this.constainsFilter.doFilter(itemToFiltre, aField, value);
            })
        }
        else {
            result = result || this.constainsFilter.doFilter(itemToFiltre, aField, values);
        }
    });
    return result;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/contains-multiple.filter.ts